import {
  Charsets_getInstanceqkyjyusuh1b0 as Charsets_getInstance,
  encodeToByteArrayomtvgs5lyogm as encodeToByteArray,
} from '../charsets/Charset.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  readString2nvggcfaijfhd as readString,
  readString3v6duspiz33tv as readString_0,
  writeString33ca4btrgctw7 as writeString,
} from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  decode1t43jmuxrxpmo as decode,
  encodeToImpl35qnqj6vvbsjt as encodeToImpl,
} from '../charsets/Encoding.mjs';
import { encodeToByteArray22651fhg4p67t as encodeToByteArray_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readText(_this__u8e3s4, charset, max) {
  charset = charset === VOID ? Charsets_getInstance().e4q_1 : charset;
  max = max === VOID ? 2147483647 : max;
  if (charset.equals(Charsets_getInstance().e4q_1)) {
    if (max === 2147483647)
      return readString(_this__u8e3s4);
    var tmp0 = _this__u8e3s4.u3z().q2();
    // Inline function 'kotlin.math.min' call
    var b = fromInt(max);
    var count = tmp0 <= b ? tmp0 : b;
    return readString_0(_this__u8e3s4, count);
  }
  return decode(charset.h4q(), _this__u8e3s4, max);
}
function toByteArray(_this__u8e3s4, charset) {
  charset = charset === VOID ? Charsets_getInstance().e4q_1 : charset;
  if (charset.equals(Charsets_getInstance().e4q_1))
    return encodeToByteArray_0(_this__u8e3s4, VOID, VOID, true);
  return encodeToByteArray(charset.i4q(), _this__u8e3s4, 0, _this__u8e3s4.length);
}
function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
  charset = charset === VOID ? Charsets_getInstance().e4q_1 : charset;
  if (charset === Charsets_getInstance().e4q_1) {
    return writeString(_this__u8e3s4, toString(text), fromIndex, toIndex);
  }
  encodeToImpl(charset.i4q(), _this__u8e3s4, text, fromIndex, toIndex);
}
//region block: exports
export {
  readText as readText27783kyxjxi1g,
  toByteArray as toByteArray1i3ns5jnoqlv6,
  writeText as writeText19qfzm98fbm4l,
};
//endregion

//# sourceMappingURL=Strings.mjs.map
